<template>
  <div id="tabContainer" class="app-main-content">
    <cargo-up-down-resize
      class="app-main-inner section"
      :up-style="{ display: 'flex', flexDirection: 'column', paddingBottom: '5px' }"
      :down-style="{ display: 'flex', flexDirection: 'column', paddingTop: '5px' }"
      style="height: 100%"
    >
      <template slot="up">
        <div class="section operations">
          <div v-show="cooperateEdit" class="triggers">
            <span v-if="enableUiCustom" class="title" style="margin: 7px 10px 7px 0px;">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <div v-show="isEdit">
              <el-button no="1" type="primary" :disabled="selectedContainerUsage === null" @click="changeSealHandler">
                {{ $t('SeaExport.SealNoChangeAdfterInspection') }}
              </el-button>
              <el-button no="2" type="primary" :disabled="isAutoLoad" @click="autoLoadHandler">{{
                $t('SeaExport.AutoAllocation') }}</el-button>
              <el-button type="primary" @click="autoLoadContractHandler">{{ $t('SeaExport.AutoAllocationContract')
              }}</el-button>
              <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
                {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
              </el-button>
              <el-button
                v-if="!job.lclMasterUuid"
                no="4"
                type="danger"
                :disabled="selectedContainerUsage === null"
                @click="deleteContainerHandler"
              >{{ $t('SeaExport.DeleteTheLoadingRecord') }}
              </el-button>
              <!--      编辑NCM No.-->
              <el-button
                v-if="!job.lclMasterUuid"
                no="ncmNo"
                type="primary"
                :disabled="selectedContainerUsage === null"
                @click="editNcmNoHandler(true)"
              >{{ $t('CargoMsg.Cargo_Edit') + 'NCM No.' }}
              </el-button>
              <el-button
                v-if="!job.lclMasterUuid"
                no="4"
                type="primary"
                :disabled="selectedContainerUsage === null"
                @click="editNcmNoHandler(false)"
              >{{ $t('CargoMsg.Cargo_Edit') + $t('CargoMsg.Cargo_WoodenPackagingType') }}
              </el-button>
              <el-button v-if="isFCL" no="5" type="primary" @click="downTemplateBtn_clickHandler">
                {{ $t('SeaExport.TemplateDownload') }}
              </el-button>
              <el-upload
                action="string"
                :http-request="importExcelEventHandler"
                :show-file-list="false"
                accept=".xls, .xlsx"
                :before-upload="beforeUploadUsage"
                style="display: inline-block;padding-left: 5px;"
                no="6"
              >
                <el-button v-if="isFCL" v-show="isEdit" type="primary" no="7">{{ $t('SeaExport.ExcelImport') }}</el-button>
              </el-upload>
              <el-badge v-if="job.uuid" :is-dot="harbourCheckRead" class="item">
                <el-button v-if="job.uuid" no="8" class="share-button" type="primary" @click="harbourCompare">{{
                  $t('SeaExport.UpdatePortAreaData') }}</el-button>
              </el-badge>
              <el-button v-if="job.uuid" no="copyDoorPoint" type="primary" size="mini" @click="copyDoorPointData">{{
                $t('SeaExport.CopyDoorPoint') }}</el-button>
            </div>
            <div v-if="!isEdit && isHZ">
              <el-menu
                text-color="#404144"
                active-text-color="#404144"
                mode="horizontal"
                class="el-menu-button el-button el-button--primary el-button--mini"
                style="width: 90px;vertical-align: top"
                @select="toEDIContainers"
              >
                <el-submenu index="index">
                  <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIContainers') }}</span>
                  <el-submenu index="original">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item index="API0">API</el-menu-item>
                  </el-submenu>
                </el-submenu>
              </el-menu>
            </div>
            <div>
              <span>
                {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
                <el-button v-show="btnshowAWindow && !isEdit" type="primary" class="can-operate" no="9" @click="showAWindowClickHandler">{{
                  $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
              </span>
            </div>
            <div v-if="openXhqCustomsAll && !job.lclMasterUuid" style="float: right">
              <el-button type="primary" @click="xhqShowSendContainerHandler">{{ $t('CargoMsg.SendContainer') }}</el-button>
            </div>
            <div v-if="jingyuWarehouse && !job.lclMasterUuid">
              <el-button no="ReleaseJY" type="primary" style="margin-left: 200px;" @click="toReleaseJY">{{ $t('SeaExport.ReleaseJY') }}</el-button>
              <el-button no="TakeContainerJY" type="primary" @click="toTakeContainerJY">{{ $t('SeaExport.TakeContainerJY') }}</el-button>
              <el-button no="ContainerPreloadJY" type="primary" @click="toContainerPreloadJY">{{ $t('SeaExport.ContainerPreloadJY') }}</el-button>
              <!--              <el-button no="CancelContainerPreloadJY" type="danger" @click="toCancelContainerPreloadJY">{{ $t('SeaExport.CancelContainerPreloadJY') }}</el-button>-->
            </div>
          </div>
        </div>
        <cargo-ag-grid
          config-module="130115"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="containerUsages"
          :wrap-text="true"
          style="width:100%;height:100%"
          @gridReady="params => gridApi = params.api"
        />
      </template>
      <template slot="down">
        <portData-goods-info
          ref="portDataGoodsInfo"
          :job="job"
          :is-editing="isEditGoods && isEdit"
          :is-or-not-display-so-no="true"
          :is-add-spelling="job.spelling"
          :del-po-items-uuids="delPoItemsUuids"
          :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
          :is-uppercase-by-config="isUppercaseByConfig"
          :title="enableUiCustom ? $t('SeaExport.BoxContents') : ''"
          :element-dict="enableUiCustom ? goodsElementDict : null"
          @change="handleChange"
        />
        <div v-if="jingyuWarehouse" style="width:80px">
          <span v-show="jingyuWarehouse && !isEdit" style="flex-direction: row-reverse;display: flex;justify-content: center;align-items: center;color:deepskyblue;" @click="showLclDynamicList"> {{ $t('SeaExport.LclDynamic') }} <i :class="jyLclDynamicDialog.visible?'el-icon-caret-bottom':'el-icon-caret-top'" /> </span>
        </div>
      </template>
    </cargo-up-down-resize>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />

    <!-- 查看关联业务 -->
    <associated-business-dialog
      :visible.sync="associatedBusinessDialog.visible"
      :a-data="associatedBusinessDialog.aData"
      :job="job"
      @refresh="refresh"
    />

    <!-- 港区数据对比弹窗 -->
    <new-compare-harbour-dialog
      :visible.sync="harbourDialog"
      :data-source="poItems"
      :harbour-source="sourceList"
      :job="job"
      :hc-flag="hcFlag"
      :hq-flag="hqFlag"
      :container-height-flag="containerHeightFlag"
      :h-q-h-c-flag="HQHCFlag"
      @addContainer="handleAddContainer"
    />
    <!-- 在线客服 -->

    <!-- 抄录门点拖柜数据 -->
    <tab-container-record-link-dialog
      :visible.sync="containerRecordDialog.visible"
      :job-uuid="job.uuid"
      @selectTruckingRecordHandler="selectTruckingRecordHandler"
    />

    <!-- 箱子信息对比提示弹窗 -->
    <box-Information-Verification
      :dialog-visible.sync="dialogVisible"
      :content-show="contentShow"
      :container="container"
      :job-uuid="job.uuid"
    />

    <!-- 发送装箱信息到信号旗 -->
    <xhq-send-container-dialog
      v-if="openXhqCustomsAll"
      :dialog-visible.sync="xhqSendContainerDialog.visible"
      :job="job"
      :container-usage="xhqSendContainerDialog.containerUsage"
      :selected-container="xhqSendContainerDialog.container"
    />
    <!-- 编辑NCM 木制包装类型 -->
    <ncn-edit-dialog :job="job" :containers="ncnEditDialog.containers" :title="ncnEditDialog.title" :is-ncm-no="ncnEditDialog.isNcmNo" :visible.sync="ncnEditDialog.visible" @ncnEditChange="ncnEditChange" />
    <!-- 精谕放单弹窗 -->
    <jy-release-dialog :job="job" :containers="jyReleaseDialog.containers" :visible.sync="jyReleaseDialog.visible" />
    <!-- 精谕提箱弹窗 -->
    <jy-take-container-dialog :job="job" :containers="jyTakeContainerDialog.containers" :visible.sync="jyTakeContainerDialog.visible" />
    <!-- 精谕装箱弹窗 -->
    <jy-container-preload-dialog :job="job" :containers="jyContainerPreloadDialog.containers" :visible.sync="jyContainerPreloadDialog.visible" />
    <!-- 精谕拼箱动态弹窗 -->
    <jy-lcl-dynamic-dialog :job-uuid="job.uuid" :visible.sync="jyLclDynamicDialog.visible" />
    <!-- api选择弹框 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      :is-hz="isHZ"
      @selectedApi="selectedApiCallback"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import { Job } from '@/class/model/booking/Job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import StrUtils from '@/utils/StrUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TabError } from '@/utils/class/TabError'
import { deepClone, sortByMultiField } from '@/utils'
import AssociatedBusinessDialog from '@/components/Cargo/Job/associatedBusinessDialog'
import { queryAssociatedBusiness, importExcelData, getGoodsTmpInfoByJobId, checkRead, updateRead, updateDataState, deleteByManifestInfoIdAndDataType } from '@/api/seaExport/containerUsage'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { roundHalfUp } from '@/utils/NumberUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import portDataGoodsInfo from '../portDataGoodsInfo'
import { getOpenPortDataService } from '@/api/sysManage/subscribePortPushRule'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ManifestGoodsInfo } from '@/class/model/booking/ManifestGoodsInfo'
import CargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import TabContainerRecordLinkDialog from '@/components/Cargo/Job/tabContainerRecordLinkDialog'
import BoxInformationVerification from './TabDataTracking/components/boxInformationVerification'
import { portContainerInfo } from '@/api/seaExport/dataTracking'
import NewCompareHarbourDialog from '@/components/Cargo/Job/newCompareHarbourDialog'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import XhqSendContainerDialog from '@/components/Cargo/Job/xhqSendContainerDialog'
import { jydSendJobInfo, xhqGetContainerLclList } from '@/api/seaExport/seaCargoDoc'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'
import CargoAgGridColumnEditGroup2 from '@/components/Cargo/Common/CargoAgGridColumnEditGroup2'
import CargoAgGridColumnEditGroupFive from '@/components/Cargo/Common/CargoAgGridColumnEditGroupFive'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup'
import {
  getObjectByCache
} from '@/utils/basicDataCache'
import JyContainerPreloadDialog from '@/components/Cargo/Job/jyContainerPreloadDialog.vue'
import JyTakeContainerDialog from '@/components/Cargo/Job/jyTakeContainerDialog.vue'
import ncnEditDialog from '@/components/Cargo/Job/NcnEditDialog.vue'
import JyReleaseDialog from '@/components/Cargo/Job/jyReleaseDialog.vue'
import { checkIfReleased } from '@/api/booking/jyWarehouse'
import JyLclDynamicDialog from '@/components/Cargo/Job/jyLclDynamicDialog'
import { FR } from '@/class/cargo/model/parameters/PartyIdType'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { cache } from '@/utils/cacheManager'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import * as ediApi from '@/api/seaExport/edi'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import lang from '@/lang'
import { TEMP_UNIT_CEL, VENTILATION_CBM, VENTILATION_UNIT } from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { ContainerUsage } from '@/class/model/booking/ContainerUsage'
import { PoItems } from '@/class/model/booking/PoItems'

export default {
  name: 'TabContainer',
  components: { NewCompareHarbourDialog, CargoUpDownResize, AssociatedBusinessDialog, SealNumberChangeDialog, portDataGoodsInfo, TabContainerRecordLinkDialog, BoxInformationVerification,
    XhqSendContainerDialog, JyContainerPreloadDialog, JyTakeContainerDialog, JyReleaseDialog, JyLclDynamicDialog, ncnEditDialog, ApiPopup },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    slaveCustomsDeclarationEnable: { // 【小票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    enableUiCustom: { type: Boolean, default: false } // 是否启用UI自定义
  },
  data() {
    return {
      URL,
      contentShow: true,
      container: {
        harbourDistrict: [],
        basicTab: []
      },
      dialogVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor,
          CargoAgGridColumnEditGroup2,
          CargoAgGridColumnEditGroupFive
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.itemClickHandler,
        onRowDragEnd: this.onRowDragEnd
      },
      gridApi: null,
      boxNoDialog: {
        visible: false
      },
      associatedBusinessDialog: {
        visible: false,
        aData: {}
      },
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      job: new Job().fillDefaultValue().getData(),
      containerUsages: [], // 装箱列表数据List
      dgContainerEditable: false, // 列表是否允许编辑
      selectedContainerUsage: null,
      isFCL: false, //  是否为整箱
      btnshowAWindow: false,
      isUpdateCargoDoc: false, // 修改了件毛体则为true,作用是同步了件毛体信息需要参与入库修改
      isTabBasic: true, // CARGO-7908 (cargo 中在bookingworkspace 中设置的是true)
      isAutoLoad: false,
      openPortDataService: 1, // 港区推送状态 1）不在服务范围内，且没开通服务；2）在服务范围内，且没开通服务；3）不在服务范围内，且开通服务；4）在数据服务范围内，且开通服务
      harbourList: [], // 港区推送数据,
      hasCompareYet: false,
      mergeHarbourList: [], // 港区数据合并(即合并货物信息)
      harbourCheckRead: false, // 校验港区数据推送是否已读
      harbourDialog: false, // 数据对比弹框
      sourceList: [], // 对比数据源
      manifestGoods: {},
      isEditGoods: false, // 控制货物信息
      poItems: [],
      selection: [],
      delPoItemsUuids: [],
      containerRecordDialog: {// 抄录门点拖柜弹窗
        visible: false
      },
      ncnEditDialog: {
        visible: false,
        containers: [],
        title: null,
        isNcmNo: false
      },
      containerHeightFlag: true,
      xhqSendContainerDialog: {
        visible: false,
        containerUsage: [],
        container: {}
      },
      xinHaoQiApi: 0,
      jingyuWarehouse: false,
      jyReleaseDialog: {
        visible: false
      },
      jyTakeContainerDialog: {
        visible: false,
        containers: []
      },
      jyContainerPreloadDialog: {
        visible: false,
        containers: []
      },
      jyLclDynamicDialog: {
        visible: false
      },
      isHZ: false,
      isXy: false,
      soNoAllSet: new Set(),
      apiPopup: { // api弹框
        visible: false,
        title: '',
        state: '',
        interfaceType: 1,
        interfaceArray: ''
      },
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      usageElementDict: {},
      goodsElementDict: {}
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      let printHblZbLock = false
      if (this.job.cargoDoc) {
        for (const doc of this.job.cargoDoc) {
          if (doc.docType === CargoDocConsts.HBL) {
            printHblZbLock = (doc.state === 2 && Number(this.config.get('HBLPrintLockTab')) === 1)
          }
        }
      }
      return this.action !== 'look' && !printHblZbLock
    },
    user() {
      return this.context.user || {}
    },
    openXhqCustomsAll() { // 信号旗参数等于2，推送信号旗报关单，同时接收回传文件 (完整模式)
      return Number(this.config.get('xinHaoQiApi')) === 2
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    },
    columnDefs() {
      let defs =
        [
          {
            headerName: '',
            colId: 'serialNo',
            field: '',
            width: 60,
            rowDrag: this.dgContainerEditable && this.isEdit,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            lockVisible: true,
            wrapText: false // 去除因拖拽而导致的行自动撑高
          },
          {
            headerName: this.$t('SeaExport.ContainerSize'),
            colId: 'eqSize',
            field: 'eqSize',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'eqSize')
            },
            valueFormatter: (params) => {
              return this.subClassLabelFunction(params.data, 'eqSize')
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerType'),
            colId: 'eqType',
            field: 'eqType',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'eqType')
            },
            valueFormatter: (params) => {
              return this.subClassLabelFunction(params.data, 'eqType')
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellStyle: (params) => {
              return this.containerNbrStyleFunction(params)
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: true,
              isTrim: true,
              multiplePaste: { isUppercase: true, isTrim: true }
            },
            onCellValueChanged: p => {
              const { newValue, oldValue, node, colDef } = p
              if (newValue && newValue.length > 11) {
                this.$message.warning(this.$t('SeaExport.ContainerNoOutOfRange'))
                node.setDataValue(colDef.colId, oldValue)
                return
              }
              const check = JobUtils.checkCNoHandler(this.job, oldValue)
              if (check) {
                node.setDataValue(colDef.colId, oldValue)
                return
              }
              this.onCellChange(p)
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerWeight'),
            colId: 'containerWeight',
            field: 'containerWeight',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'containerWeight')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            cellStyle: (params) => {
              return this.sealNoStyleFunction(params)
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: true,
              isTrim: true,
              multiplePaste: { isUppercase: true, isTrim: true }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'quantity')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
            editable: this.dgContainerEditable && this.isEdit && this.isJydEditJobFields,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0
              },
              multiplePaste: { isNumber: true, precision: 0 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.GrossWeight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'weight')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit && this.isJydEditJobFields,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'cubage')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit && this.isJydEditJobFields,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: 'NCM No.',
            field: 'ncmNo',
            colId: 'ncmNo',
            minWidth: 250,
            tooltipValueGetter: (params) => {
              return params.value
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_WoodenPackagingType'),
            field: 'woodenPackagingType',
            colId: 'woodenPackagingType',
            minWidth: 250,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_WoodenPackageType, 'code', params.value, 'name')
            },
            tooltipValueGetter: (params) => {
              return params.value + ' [' + ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_WoodenPackageType, 'code', params.value, 'name') + ']'
            }
          },
          {
            headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
            colId: 'cargoName',
            field: 'cargoName',
            width: 120,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            colId: 'mark',
            field: 'mark',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Soc'),
            colId: 'soc',
            field: 'soc',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.dgContainerEditable && this.isEdit,
              tag: 'el-checkbox',
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Inspection'),
            colId: 'inSpected',
            field: 'inSpected',
            width: 100,
            valueFormatter: (params) => {
              return this.subInSpectedLabelFunc(params.data)
            }
          },
          {
            headerName: 'HSCODE',
            colId: 'hsCode',
            field: 'hsCode',
            width: 120,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              field: 'hsCode',
              multiplePaste: {}
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.ApproachDate'),
            colId: 'approachDate',
            field: 'approachDate',
            width: 120,
            hide: true
          },
          {
            // 出场时间
            headerName: this.$t('SeaExport.PlayDate'),
            colId: 'playDate',
            field: 'playDate',
            width: 120,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.LoadingPort'),
            colId: 'loadingPort',
            field: 'loadingPort',
            hide: true,
            width: 100
          },
          {
            headerName: this.$t('SeaExport.PortOfDestination'),
            colId: 'destinationPort',
            field: 'destinationPort',
            hide: true,
            width: 100
          },
          {
            headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
            colId: 'transportMessageDate',
            field: 'transportMessageDate',
            hide: true,
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            // 海关放行信息
            headerName: this.$t('SeaExport.CustomsClearanceInfo'),
            colId: 'customReleaseDate',
            field: 'customReleaseDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              if (params.data.customReleaseState === 'R') {
                return 'R(' + this.$t('SeaExport.CancelCustomsClearance') + ')'
              }
              if (params.data.customReleaseState) {
                return params.data.customReleaseState === 'Y' ? `${params.data.customReleaseState}(${params.data.customReleaseDate})` : params.data.customReleaseState
              } else {
                return params.data.customReleaseDate
              }
            }
          },
          {
            // 码头放行信息
            headerName: this.$t('SeaExport.WharfReleaseInfo'),
            colId: 'wharfReleaseDate',
            field: 'wharfReleaseDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              if (params.data.wharfReleaseState === 'R') {
                return 'R(' + this.$t('SeaExport.CancelDockRelease') + ')'
              }
              if (params.data.wharfReleaseDate) {
                return params.data.wharfReleaseState ? `${params.data.wharfReleaseState}(${params.data.wharfReleaseDate})` : params.data.wharfReleaseDate
              } else {
                return params.data.wharfReleaseState ? params.data.wharfReleaseState : ''
              }
            }
          },
          {
            headerName: this.$t('SeaExport.LFD'),
            colId: 'lfd',
            field: 'lfd',
            hide: true,
            width: 160,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            valueFormatter: (params) => {
              return params.value ? ColumnUtils.dateTimeLabelFunc(params.value) : ''
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.ContainerAscription'),
            colId: 'containerAscription',
            field: 'containerAscription',
            width: 120,
            valueFormatter: (params) => {
              const options = [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE]
              const curOption = options.find(option => option.code === params.value)
              if (curOption) {
                return curOption.chineseName
              }
              return ''
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                staticOptions: [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE],
                tagValue: 'code',
                tagName: 'chineseName'
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.PlateNumber'),
            colId: 'plateNumber',
            field: 'plateNumber',
            hide: true,
            width: 120
          },
          {
            headerName: this.$t('SeaExport.plateApproachDate'),
            colId: 'plateApproachDate',
            field: 'plateApproachDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.platePlayDate'),
            colId: 'platePlayDate',
            field: 'platePlayDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.Remarks'),
            colId: 'remark',
            field: 'remark',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              multiplePaste: {}
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            // 码头配载
            headerName: this.$t('SeaExport.WharfStowage'),
            colId: 'wharfStowage',
            field: 'wharfStowage',
            valueFormatter: (params) => {
              if (params.data.wharfStowage) {
                return params.data.wharfStowageState ? `${params.data.wharfStowageState}(${params.data.wharfStowage})` : params.data.wharfStowage
              } else {
                return params.data.wharfStowageState ? params.data.wharfStowageState : ''
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Package'),
            colId: 'packing',
            field: 'packing',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Packing,
                filterable: true,
                tagValue: 'code',
                customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
                showCustomLabelInOption: true
              }
            },
            valueFormatter: params => {
              return ColumnUtils.packingCodeLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.DestinationDeliveryTime'),
            field: 'destinationDeliveryTime',
            colId: 'destinationDeliveryTime',
            width: 150,
            valueFormatter: (params) => {
              return this.destinationDisplayFunction(params, 'destinationDeliveryTime')
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.DestinationReturnTime'),
            field: 'destinationReturnTime',
            colId: 'destinationReturnTime',
            width: 150,
            valueFormatter: (params) => {
              return params.data.container ? params.data.container.destinationReturnTime : ''
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.BoxController'),
            colId: 'boxController',
            field: 'boxController',
            hide: true,
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              multiplePaste: {}
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AuthorizedQuantity'),
            colId: 'quantityContract',
            field: 'quantityContract',
            width: 100,
            hide: true,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0
              },
              multiplePaste: { isNumber: true, precision: 0 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CommissionedGrossWeight'),
            colId: 'weightContract',
            field: 'weightContract',
            width: 100,
            hide: true,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AuthorizedCubage'),
            colId: 'cubageContract',
            field: 'cubageContract',
            width: 100,
            hide: true,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DeclarationGrossWeight'),
            field: 'customsWeight',
            width: 100,
            hide: true,
            suppressColumnsToolPanel: !this.openXhqCustomsAll,
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_NumberDeclaration'),
            field: 'customsQuantity',
            width: 100,
            hide: true,
            suppressColumnsToolPanel: !this.openXhqCustomsAll,
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
            }
          },
          {
            headerName: this.$t('CargoMsg.SOCType'),
            field: 'socType',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.isEdit,
              tag: 'cargo-cell-select',
              optionField: {
                label: 'chineseName',
                value: 'code'
              },
              attrs: {
                cellSelectAttrs: { fullOptionsCBFunc: () => [...SeaExportConstants.SOC_TYPE] }
              },
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          },
          {
            headerName: this.$t('SeaExport.UnloadingTime'),
            field: 'portDischargeTime',
            colId: 'portDischargeTime',
            width: 150,
            hide: true,
            valueFormatter: (params) => {
              return this.actualDisplayFunction(params, 'portDischargeTime')
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.LiftingTime'),
            field: 'actualPickUpTime',
            colId: 'actualPickUpTime',
            width: 150,
            hide: true,
            valueFormatter: (params) => {
              return this.actualDisplayFunction(params, 'actualPickUpTime')
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('queryJob.destinationAgent'),
            field: 'destinationAgent',
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
            },
            width: 200
          },
          {
            headerName: this.$t('SeaExport.NominatedAgent'),
            field: 'designationAgent',
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
            },
            width: 200
          },
          {
            headerName: this.$t('SeaExport.UserDefinedField1'),
            field: 'userDefinedField1',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.UserDefinedField2'),
            field: 'userDefinedField2',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.UserDefinedField3'),
            field: 'userDefinedField3',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.UserDefinedField4'),
            field: 'userDefinedField4',
            width: 150
          },
          {
            headerName: this.$t('queryJob.BusinessRemarks'),
            field: 'jobRemarks',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            field: 'soNo',
            width: 150,
            valueFormatter: (params) => {
              return params.value ? params.value.replace(/\n/g, ',') : ''
            }
          },
          {
            headerName: this.$t('SeaExport.RelevanceSoNo'),
            field: 'relevanceSoNo',
            width: 150,
            // valueFormatter: (params) => {
            //   return params.value ? params.value.replace(/\n/g, ',') : ''
            // },
            hide: true,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
            cellEditorParams: {
              selectProps: {
                multiple: true,
                tagValue: 'soNo',
                tagName: 'soNo',
                staticOptions: [...this.soNoAllSet],
                filterable: true
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('queryJob.QuantityWeightCubageConfirmed'),
            field: 'quantityWeightCubageConfirmed',
            width: 100,
            valueFormatter: (params) => {
              return ColumnUtils.booleanColumnLabelFunc(params.value)
            },
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.isEdit && !this.job.lclMasterUuid,
              tag: 'el-checkbox',
              valueChanged: p => this.onCellChange(p)
            }
          },
          {
            headerName: this.$t('SeaExport.OperationTips'),
            field: 'operationTips',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.ContainerId'),
            field: 'containerId',
            hide: true,
            width: 80
          },
          {
            headerName: this.$t('SeaExport.ContainerSeqNo'),
            field: 'containerSeqNo',
            hide: true,
            width: 80
          }
        ]
      if (this.isShowSize()) {
        defs.push(
          {
            headerName: this.$t('SeaExport.Dimensions'),
            field: 'dimension',
            colId: 'dimension',
            minWidth: 250,
            editable: (params) => {
              return this.dimensionEditable(params)
            },
            suppressKeyboardEvent: true,
            cellEditor: 'CargoAgGridColumnEditGroup2',
            cellEditorParams: {
              valueChanged: this.calculationDimension,
              min: 0,
              precision: 2
            },
            onCellValueChanged: this.calculationDimension
          }
        )
      }
      if (this.hasReefer()) {
        defs.push({
          headerName: this.$t('SeaExport.Temperature'),
          colId: 'reefTemperature',
          field: 'reefTemperature',
          width: 100,
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.reefer
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            multiplePaste: {}
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SpecialGoods.TemperatureUnit'),
          colId: 'reefTempUnit',
          field: 'reefTempUnit',
          width: 120,
          valueFormatter: (params) => {
            const options = [...SeaExportConstants.REEF_TEMP_UNIT]
            const curOption = options.find(option => option.code === params.value)
            if (curOption) {
              return curOption.chineseName
            }
            return SeaExportConstants.TEMP_UNIT_CEL.chineseName
          },
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.reefer
          },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...SeaExportConstants.REEF_TEMP_UNIT],
              tagValue: 'code',
              tagName: 'chineseName'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.OpenVentilation'),
          colId: 'ventilate',
          field: 'ventilate',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            attrs: {
              isEditCBFunc: (params) => {
                return this.dgContainerEditable && this.isEdit && params.data.reefer
              }
            },
            tag: 'el-checkbox',
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.VentilationQuantity'),
          colId: 'reefVentilation',
          field: 'reefVentilation',
          width: 100,
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.reefer
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            multiplePaste: {}
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.VentilationUnit'),
          colId: 'ventilationUnit',
          field: 'ventilationUnit',
          width: 120,
          valueFormatter: (params) => {
            const options = [...SeaExportConstants.VENTILATION_UNIT]
            const curOption = options.find(option => option.code === params.value)
            if (curOption) {
              return curOption.chineseName
            }
            return SeaExportConstants.VENTILATION_CBM.chineseName
          },
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.reefer
          },
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...SeaExportConstants.VENTILATION_UNIT],
              tagValue: 'code',
              tagName: 'chineseName'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.Humidity'),
          colId: 'humidity',
          field: 'humidity',
          width: 100,
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.reefer
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            multiplePaste: {}
          },
          onCellValueChanged: p => this.onCellChange(p)
        })
      }
      if (this.hasOverSize()) {
        defs.push({
          headerName: this.$t('SeaExport.OverSize'),
          colId: 'overSize',
          field: 'overSize',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            attrs: {
              isEditCBFunc: (params) => {
                return this.dgContainerEditable && this.isEdit && params.data.specialSize
              }
            },
            tag: 'el-checkbox',
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: 'BBK',
          colId: 'checkBbk',
          field: 'checkBbk',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            attrs: {
              isEditCBFunc: (params) => {
                return this.dgContainerEditable && this.isEdit && params.data.eqType === FR.code
              }
            },
            tag: 'el-checkbox',
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OOGTEU'),
          colId: 'oogTeu',
          field: 'oogTeu',
          width: 250,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2, true)),
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.overSize
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2
            },
            multiplePaste: { isNumber: true, precision: 2 }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.ZYQHG'),
          field: 'overSizeData',
          colId: 'overSizeData',
          minWidth: 250,
          editable: (params) => {
            return this.dgContainerEditable && this.isEdit && params.data.specialSize
          },
          suppressKeyboardEvent: true,
          cellEditor: 'CargoAgGridColumnEditGroupFive',
          cellEditorParams: {
            valueChanged: this.calculationOverSizeData,
            min: 0,
            precision: 2
          },
          onCellValueChanged: this.calculationOverSizeData
        },)
      }
      if (this.enableUiCustom) {
        defs = UICustomUtil.handleColumnLabelAndDisplay(defs, this.usageElementDict)
      }
      return defs
    },
    config() {
      return this.context.config
    },
    language() {
      return this.$store.getters.language
    },
    hqFlag() {
      if (this.job.containers.length > 0) {
        for (const data of this.job.containers) {
          // 记录HQ/HC箱型存在的标识
          if (data.eqType === 'HQ') {
            return true
          }
        }
      }
      return false
    },
    hcFlag() {
      if (this.job.containers.length > 0) {
        for (const data of this.job.containers) {
          // 记录HQ/HC箱型存在的标识
          if (data.eqType === 'HC') {
            return true
          }
        }
      }
      return false
    },
    HQHCFlag() {
      if (this.hqFlag && this.hcFlag) {
        return true
      }
      return false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.jingyuWarehouse = this.context.config.get('JingyuWarehouse') === '1'
    this.isHZ = String(cache.config.get('ToExoSystem')) === 'HZ'
    this.isXy = String(cache.config.get('ToExoSystem')) === 'XYCW'
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    // this.context.loading = true
    // await this.context.prepareData()
  },
  methods: {
    loadPageConfig() {
      this.usageElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CONTAINER_INFO, this.$store.getters.currentOfficeId, undefined, 'ContainerInfo2').elementDict
      this.goodsElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CONTAINER_INFO, this.$store.getters.currentOfficeId, undefined, 'BoxContents').elementDict
    },
    async onShow(row, isRefresh) {
      this.dialogVisible = false
      let usageDirty = false
      // [copydiag] 集装箱 tab onShow 入参现场
      // eslint-disable-next-line no-console
      console.log('[copydiag] tabContainer.onShow IN', {
        uuid: row.uuid,
        isRefresh,
        seaEQ: (row.seaEQ || []).length,
        containerUsages: Array.isArray(row.containerUsages) ? row.containerUsages.length : row.containerUsages,
        containers: Array.isArray(row.containers) ? row.containers.length : row.containers
      })
      if (row.containerUsages && row.containerUsages.length > 0) {
        for (const usage of row.containerUsages) {
          // newContainerNo用于标记哪个箱号被删除了，从而清空相关的港口海放码放等信息
          usage.newContainerNo = usage.containerNo
          if (usage.hasOwnProperty('isDirty') && usage.isDirty) {
            usageDirty = usage.isDirty
            break
          }
        }
      }
      this.job = row
      if (!isRefresh && !usageDirty) {
        // 同步共享状态到本地，不调用 clearContainer 避免污染共享的 row 对象
        if (row.containerUsages && row.containerUsages.length > 0 && row.seaEQ && row.seaEQ.length > 0) {
          this.containerUsages = [...row.containerUsages]
        } else {
          this.containerUsages = []
        }
        if (this.gridApi) {
          this.gridApi.setRowData(this.containerUsages)
        }
        if (this.slaveCustomsDeclarationEnable) {
          PortDataCompareUtils.initContainerPoItemsMultiSoNoMode(this.containerUsages, this.poItems, this.job.uuid)
          if (this.gridApi) {
            this.gridApi.refreshCells({ force: true })
          }
          if (this.$refs.portDataGoodsInfo && this.$refs.portDataGoodsInfo.gridApi) {
            this.$refs.portDataGoodsInfo.gridApi.refreshCells({ force: true })
          }
        }
        return
      }
      this.job = row
      this.mergeHarbourList = []
      this.selection = []
      this.isAutoLoad = false
      if (this.job.uuid) {
        await this.initHarbour()
        const showBoxInformationVerification = LocalStorageUtilsNew.getConfiguration('BoxInformationVerification_' + this.job.uuid)
        if (this.readonly && !row.lclMasterUuid && !showBoxInformationVerification) {
          this.portContainerInfoFunc(row)
        }
      }
      await this.jobChanged()
      this.getAllSoNoHandler()
      this.btnshowAWindow = (StrUtils.isEmpty(this.job.relatedJob) && !StrUtils.isEmpty(this.job.trustFromJob)) ||
        (StrUtils.isEmpty(this.job.trustFromJob) && !StrUtils.isEmpty(this.job.relatedJob))
      this.initCompare()
    },
    getAllSoNoHandler() {
      this.soNoAllSet = new Set()
      if (this.job.soNo) {
        // 根据换行符分隔
        const soNoArr = this.job.soNo.split('\n')
        for (const soNo of soNoArr) {
          const cData = {}
          cData['soNo'] = soNo
          this.soNoAllSet.add(cData)
        }
      }
    },
    // 计算重复箱子数量
    counterArray(arr) {
      var obj = {}
      arr.forEach(function(v, k) {
        if (obj[v]) {
          obj[v]++
        } else {
          obj[v] = 1
        }
      })
      return obj
    },
    // 获取港区箱子
    async portContainerInfoFunc(row) {
      const params = {
        jobUuid: row.uuid,
        userId: this.$store.getters.userId,
        discriminate: 2,
        tenantId: row.tenantId
      }
      try {
        const res = await portContainerInfo(params)
        if (res && res.ok && res.data && res.data.length > 0) {
          this.container.harbourDistrict = []
          this.container.basicTab = []
          this.contentShow = true
          // 箱量不一致弹出

          const containerArr = []
          // 计算有多少个箱号
          for (const data of res.data) {
            if (!containerArr.includes(data.containerNo)) {
              containerArr.push(data.containerNo)
            }
          }
          // 记录箱号有几个，用于判断箱量是否相等
          const containersNum = containerArr.length
          // 组装基本页签箱子
          if (row.containers.length > 0) {
            for (const data of row.containers) {
              this.container.basicTab.push(`${data.eqSize}'${data.eqType}`)
            }
            const containers = this.counterArray(this.container.basicTab)
            const newContainers = []
            Object.keys(containers).forEach((item) => {
              newContainers.push(`${item}*${containers[item]}`)
            })
            this.container.basicTab = newContainers
          }
          for (const data of res.data) {
            // 标记无容器高度
            this.containerHeightFlag = !!data.containerHeightCn
            // 转换箱型箱种的映射
            data.eqtype = PortDataCompareUtils.transformEqType(data.eqtype, data.containerHeightCn, this.HQHCFlag)
            containerArr.forEach((item, index) => {
              // 港区数据与所有不重复的箱号进行对比，记录箱型箱种
              if (item === data.containerNo) {
                // 转换后的eqtype为数组 如数组长度大于1代表映射关系有两种，取HC作为弹窗内的默认显示值
                if (data.eqtype.length > 1) {
                  if (data.containerHeightCn) {
                    // this.container.harbourDistrict.push(`${data.eqsize}'HC`)
                    if (!this.hqFlag || !this.hcFlag) {
                      if (this.hqFlag) {
                        this.container.harbourDistrict.push(`${data.eqsize}'HQ`)
                      } else {
                        this.container.harbourDistrict.push(`${data.eqsize}'HC`)
                      }
                    }
                  } else {
                    if (!this.hqFlag || !this.hcFlag) {
                      if (this.hqFlag) {
                        this.container.harbourDistrict.push(`${data.eqsize}'HQ`)
                      } else {
                        this.container.harbourDistrict.push(`${data.eqsize}'HC`)
                      }
                    }
                  }
                } else {
                  this.container.harbourDistrict.push(`${data.eqsize}'${data.eqtype}`)
                }
                containerArr.splice(index, 1)
              }
            })
          }
          // 统计重复的箱子，避免提示的箱型箱种有多个重复的
          const totalize = this.counterArray(this.container.harbourDistrict)
          const temporaryArr = []
          Object.keys(totalize).forEach((item) => {
            temporaryArr.push(`${item}*${totalize[item]}`)
          })
          this.container.harbourDistrict = temporaryArr

          if (row.containers.length !== containersNum) {
            this.contentShow = false
          } else {
            if (!this.container.basicTab.every(el => this.container.harbourDistrict.indexOf(el) !== -1)) {
              this.contentShow = false
            }
          }
          if (!(this.hasCompareYet && this.contentShow)) {
            this.dialogVisible = true
          }
        }
      } catch (e) {

      }
    },
    // 当箱货信息清空时，对应的装箱和装箱明细也要清空
    clearContainer(row) {
      ContainerUtil.clearContainer(row)
      if (!row.seaEQ || row.seaEQ.length <= 0) {
        this.containerUsages = []
        if (this.gridApi) {
          this.gridApi.setRowData([])
        }
        this.refreshTotal()
      }
    },
    endTabHandler() {
      this.stopEditing()
      this.fillModel()
    },
    stopEditing() {
      // 处理部分显示列 未结束编辑,就因箱子类型变动，删除异常
      this.gridApi.stopEditing()
    },
    async jobChanged() {
      if (!this.job) return

      const job = new SeaExportJob(this.job)
      await Promise.all([
        job.getLclMaster(),
        job.getSeaEQ(),
        job.getCargoDoc(),
        job.getContainerUsages(),
        job.getContainers(),
        job.getPoItems()
      ])
      // [copydiag] jobChanged 取数后现场
      // eslint-disable-next-line no-console
      console.log('[copydiag] jobChanged after get* ', {
        jobState: this.job.jobState,
        action: this.action,
        seaEQ: (this.job.seaEQ || []).length,
        containers: Array.isArray(this.job.containers) ? this.job.containers.length : this.job.containers,
        containerUsages: Array.isArray(this.job.containerUsages) ? this.job.containerUsages.length : this.job.containerUsages
      })
      this.poItems = this.job.poItems && this.job.poItems.length > 0 ? this.job.poItems.sort((a, b) => {
        return a.sequenceNo - b.sequenceNo
      }) : []
      // 不在 load 时清：seaEQ 为空但有箱子的合法单子（拼箱/历史数据）会被误清，
      // 且 clearContainer 直接 job.containers=[] 会污染共享 job 对象（见 :1474 注释）、波及复制源对象。
      // 锦昶 cascade-clear 改由用户清空 seaEQ 时触发：bookingSeaEqDataGrid.vue:425 的 ContainerUtil.clearContainer。
      // this.clearContainer(job)

      await this.jobLoadResultHandler()

      // lcl 小票 通过 usage 关联出container
      if (job.lclMasterUuid) {
        const ctnr = []
        for (const item of job.containerUsages) {
          ctnr.push(item.container)
        }
        if (!job.containers) {
          job.containers = []
        }
        job.containers.splice(0, job.containers.length, ...ctnr)
      }

      // 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
      await ContainerUtil.buildContainerUsages(this.job)
      const containerUsages = this.job.containerUsages.sort((a, b) => {
        return a.serialNo - b.serialNo
      })
      containerUsages.forEach((item) => {
        item.customReleaseState = item.container.customReleaseState
        item.wharfStowageState = item.container.wharfStowageState
        item.wharfStowage = item.container.wharfStowage
      })
      this.containerUsages = containerUsages

      this.refreshContainerWeight()
      this.refreshTotal()

      if (this.job.lob === 'SE') {
        this.isFCL = this.job.containerLoadType === 'FCL'
      }
      // CARGO-10331 【提单制作】参数HBLZBPrintLockTab未生效，HBL已锁定仍能编辑
      this.dgContainerEditable = this.isEdit && StrUtils.isEmpty(this.job.lclMasterUuid)

      // 港区数据同步对比服务
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
        this.gridApi.refreshCells({ force: true })
        this.isEditGoods = false
        this.manifestGoods = {}
      }
      this.manifestGoods = {}
      if (this.$refs.portDataGoodsInfo) {
        this.$refs.portDataGoodsInfo.init({})
      }
      // 【多sono模式开启时】
      if (this.slaveCustomsDeclarationEnable) {
        PortDataCompareUtils.initContainerPoItemsMultiSoNoMode(this.containerUsages, this.poItems, this.job.uuid)
        if (this.gridApi) {
          this.gridApi.refreshCells({ force: true })
        }
      } else {
        PortDataCompareUtils.initContainerPoItems(this.containerUsages, this.poItems)
      }
    },

    async getSubmitData() {
      this.validate()
      this.fillModel()
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const usage of this.containerUsages) {
        if (usage.newContainerNo && !usage.containerNo) {
          usage.wharfReleaseDate = ''
          usage.wharfReleaseState = ''
          usage.wharfStowage = ''
          usage.wharfStowageState = ''
          usage.customReleaseDate = ''
          usage.customReleaseState = ''
          usage.approachDate = ''
          usage.playDate = ''
        }
        if (usage.container) {
          if (usage.newContainerNo && !usage.containerNo) {
            usage.container.wharfReleaseDate = ''
            usage.container.wharfReleaseState = ''
            usage.container.wharfStowage = ''
            usage.container.wharfStowageState = ''
            usage.container.customReleaseDate = ''
            usage.container.customReleaseState = ''
            usage.container.approachDate = ''
            usage.container.playDate = ''
          }
          if (!this.slaveCustomsDeclarationEnable) {
            usage.container.quantity = usage.quantity
            usage.container.weight = usage.weight ? usage.weight : 0
            usage.container.cubage = usage.cubage
            usage.container.sizeLength = usage.sizeLength ? usage.sizeLength : 0
            usage.container.sizeWidth = usage.sizeWidth ? usage.sizeWidth : 0
            usage.container.sizeHeight = usage.sizeHeight ? usage.sizeHeight : 0
          }
        }
        if (usage.poItems === '') {
          usage.poItems = []
        }
      }
      if (this.job.containers) {
        const cargoDocKeySet = new Set()
        if (this.job.seaCargoDoc) {
          for (const cargoDoc of this.job.seaCargoDoc) {
            cargoDocKeySet.add(cargoDoc.uuid)
          }
        }
        for (const container of this.job.containers) {
          if (container.containerUsage) {
            for (const item of container.containerUsage) {
              // 同步箱封号
              if (item.sealNo && item.sealNo !== container.sealNo) {
                container.sealNo = item.sealNo
                container.isDirty = true
              }
              if (item.poItems === '') {
                item.poItems = []
              }
              let updateEdiContainer = false
              if (this.job.uuid && item.ediContainers && item.ediContainers.length > 0) {
                for (const ediContainer of item.ediContainers) {
                  if (!cargoDocKeySet.has(ediContainer.cargoDocUuid) && (ediContainer.containerNo !== container.containerNo || ediContainer.sealNo !== container.sealNo)) {
                    ediContainer.containerNo = container.containerNo
                    ediContainer.sealNo = container.sealNo
                    updateEdiContainer = true
                  }
                }
              }
              if (!updateEdiContainer) {
                delete item.ediContainers
              }
            }
          }
        }
      }
      // 需要参与保存的装箱明细 CARGO-44605 装箱信息界面货物明细里面录入信息后会出现重复的数据
      const needSaveUsages = this.containerUsages.filter(p => !StrUtils.isEmpty(p.uuid))
      const needSaveContainers = this.job.containers.filter(p => p.isDirty === true)
      // 箱子发生变更，明细里面的poItemsMap 和 needSaveUsages是重复的，会导致数据反复插入
      if (needSaveContainers && needSaveContainers.length > 0 && needSaveUsages && needSaveUsages.length > 0) {
        const poItemsMap = new Map()
        for (const item of needSaveUsages) {
          if (item.poItems && item.poItems.length > 0) {
            poItemsMap.set(item.uuid, item.poItems)
          }
        }
        for (const container of needSaveContainers) {
          if (container.containerUsage && container.containerUsage.length > 0) {
            for (const item of container.containerUsage) {
              if (item.uuid && poItemsMap.has(item.uuid)) {
                item.poItems = poItemsMap.get(item.uuid)
                const index = needSaveUsages.findIndex(p => p.uuid && p.uuid === item.uuid)
                if (index >= 0) {
                  needSaveUsages.splice(index, 1)
                }
              }
            }
          }
        }
      }
      const job = { ...this.job }
      const result = {
        job, // 未打开过时 件毛体同步数据需要保存
        delPoItemsUuids: this.delPoItemsUuids,
        containerUsages: needSaveUsages,
        containers: needSaveContainers,
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        containerNums: this.containerUsages?.length || 0
      }
      // 修改件毛体
      if (this.isUpdateCargoDoc) {
        result.seaCargoDoc = [...job.seaCargoDoc]
      }
      if (this.job.seaEQ && this.job.seaEQ.length > 0) {
        result['seaEQ'] = this.job.seaEQ.filter(p => p.isDirty === true)
      }
      if (this.job.delseaEQUuids && this.job.delseaEQUuids.length > 0) {
        result['delseaEQUuids'] = this.job.delseaEQUuids
      }
      if (this.selection && this.selection.length > 0) {
        result['confirmedVOS'] = this.selection
      }
      return result
    },
    fillModel() {
      // CARGO-7908
      const expression = Number(this.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic && !this.slaveCustomsDeclarationEnable) {
        ContainerUtil.refContainerUsageQwc(this.job, 3)
      }
    },
    /**
     * 验证
     */
    validate() {
      if (!this.job || !this.job.containerUsages || !this.isEdit) {
        return true
      }
      if (this.enableUiCustom) {
        const containerUsageSample = new ContainerUsage().fillDefaultValue().getData()
        const poItemsSample = new PoItems().fillDefaultValue().getData()
        const convertUsageValueFunc = (data, field) => {
          switch (field) {
            case 'destinationDeliveryTime':
            case 'destinationReturnTime':
            case 'portDischargeTime':
            case 'actualPickUpTime':
              return data?.container?.[field] || ''
          }
          const type = typeof containerUsageSample[field]
          if (type === 'number') {
            return Number(data[field]) || 0
          }
          return data[field]
        }
        const convertPoItemValueFunc = (data, field) => {
          const type = typeof poItemsSample[field]
          if (type === 'number') {
            return Number(data[field]) || 0
          }
          return data[field]
        }
        UICustomUtil.checkRowDataRequire(this.containerUsages, this.usageElementDict, 'tabContainer', undefined, convertUsageValueFunc)
        for (const usage of this.containerUsages) {
          UICustomUtil.checkRowDataRequire(usage.poItems, this.goodsElementDict, 'tabContainer', (row, element) => {
            if (row.containerNo) {
              return ` 【${this.$t('SeaExport.ContainerNo')}：${row.containerNo}】${element.label} `
            }
            if (row.sealNo) {
              return ` 【${this.$t('SeaExport.SealNo')}：${row.sealNo}】${element.label} `
            }
            return element.label
          }, convertPoItemValueFunc)
        }
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabContainer')
      }
      if (this.job.containerUsages && this.job.containerUsages.length > 0) {
        for (const usage of this.job.containerUsages) {
          if (usage.overSize && (!usage.oogTeu || Number(usage.oogTeu) === 0)) {
            throw new TabError(this.$t('CargoMsg.Cargo_OOGTEUTip'), 'tabContainer')
          }
        }
      }
      return true
    },
    async jobLoadResultHandler() {
      // 根据箱型初始化箱子(待审核的时候不允许看到装箱信息)
      if (this.job.jobState > SystemConstants.PENDING) {
        await ContainerUtil.autoJustContainerUsages(this.job, this.action, false)
      }

      // 避免 JSON 对象的循环引用  sortByMultiField 报错 ，后端排序
      // this.job.containerUsages = this.sortByOrder(this.job.containerUsages)

      this.selectedContainerUsage = null

      //  需要先 关联 container 与 containerUsage之后 调用
      // await this.refreshContainerWeight()

      this.checkCargoDocState()
      // this.refreshTotal()
    },
    // 按照指定字段排序
    sortByOrder(categoryArray) {
      if (categoryArray == null || categoryArray.length === 0) {
        return null
      } else {
        categoryArray = sortByMultiField(categoryArray, ['dateCreated'], false)
      }
      return categoryArray
    },
    refreshContainerWeight() {
      for (const usage of this.containerUsages) {
        if (usage.container) {
          // 列显示 箱子相关信息 移至 usage
          const eqSize = EQSize.getEQSizeByCode(usage.container.eqSize)
          usage.eqSize = eqSize === null ? '' : eqSize.code
          usage.eqType = usage.container.eqType
          usage.containerNo = usage.container.containerNo
          usage.containerWeight = usage.container.containerWeight
          usage.sealNo = usage.container.sealNo
          usage.remark = usage.container.remark

          usage.approachDate = usage.container.approachDate
          usage.playDate = usage.container.playDate
          usage.loadingPort = usage.container.loadingPort
          usage.dischargingPort = usage.container.dischargingPort
          usage.destinationPort = usage.container.destinationPort
          usage.transportMessageDate = usage.container.transportMessageDate
          usage.wharfReleaseDate = usage.container.wharfReleaseDate
          usage.customReleaseDate = usage.container.customReleaseDate
          usage.lfd = usage.container.lfd
          usage.containerAscription = usage.container.containerAscription
          usage.plateNumber = usage.container.plateNumber
          usage.plateApproachDate = usage.container.plateApproachDate
          usage.platePlayDate = usage.container.platePlayDate
          usage.boxController = usage.container.boxController
          usage.carNumber = usage.container.carNumber
          usage.sizeLength = usage.container.sizeLength
          usage.sizeWidth = usage.container.sizeWidth
          usage.sizeHeight = usage.container.sizeHeight
          if ((!usage.sizeLength || usage.sizeLength === 0) && (!usage.sizeWidth || usage.sizeWidth === 0) && (!usage.sizeHeight || usage.sizeHeight === 0)) {
            usage.dimension = ''
          } else {
            usage.dimension = (usage.sizeLength && usage.sizeLength !== 0 ? usage.sizeLength : ' ') + '*' + (usage.sizeWidth && usage.sizeWidth !== 0 ? usage.sizeWidth : ' ') + '*' + (usage.sizeHeight && usage.sizeHeight !== 0 ? usage.sizeHeight : ' ')
          }
          usage.reefer = usage.container.reefer
          usage.specialSize = usage.container.specialSize
          usage.reefTemperature = usage.container.reefTemperature
          usage.ventilate = usage.container.ventilate
          usage.ncmNo = usage.container.ncmNo
          usage.woodenPackagingType = usage.container.woodenPackagingType
          usage.oogTeu = usage.container.oogTeu
          usage.overSize = usage.container.overSize
          usage.checkBbk = usage.container.checkBbk
          usage.reefVentilation = usage.container.reefVentilation
          usage.humidity = usage.container.humidity
          usage.overFront = usage.container.overFront
          usage.overBack = usage.container.overBack
          usage.overLeft = usage.container.overLeft
          usage.overRight = usage.container.overRight
          usage.overHeight = usage.container.overHeight
          usage.reefTempUnit = usage.container.reefTempUnit
          usage.ventilationUnit = usage.container.ventilationUnit
          if ((!usage.overFront || usage.overFront === 0) && (!usage.overBack || usage.overBack === 0) && (!usage.overLeft || usage.overLeft === 0) &&
              (!usage.overRight || usage.overRight === 0) && (!usage.overHeight || usage.overHeight === 0)) {
            usage.overSizeData = ''
          } else {
            usage.overSizeData = (usage.overLeft || ' ') + '-' + (usage.overRight || ' ') + '-' + (usage.overFront || ' ') + '-' + (usage.overBack || ' ') + '-' + (usage.overHeight || ' ')
          }
        }
      }
    },
    checkCargoDocState() {
      if (this.isEdit) {
        let unlock = true
        for (const doc of this.job.cargoDoc) {
          if (doc.docType.substr(0, 3) === 'HBL' && doc.state > 1) {
            unlock = false
            break
          }
        }
        this.dgContainerEditable = unlock && StrUtils.isEmpty(this.job.lclMasterUuid)
      }
    },
    refreshTotal() {
      let quantity = 0
      let weight = 0
      let cubage = 0

      for (const usage of this.job.containerUsages) {
        if (usage.deleted) {
          continue
        }
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = ContainerUtil.getContainerDesc(this.job)
    },
    containerNbrStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage && !ContainerNoHelper.checkContainerNo(params.value)) {
          return { color: '#F56C6C' }
        }
        if (usage.container !== null && DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
      // this.containerPushDataStyleFunction(params, 'ContainerNo')
    },
    sealNoStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage.isReSealed) {
          return { color: '#F56C6C' }
        }
        if (usage.container != null && DataPushCompareUtils.comparePushData(this.$t('SeaExport.SealNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
    },
    containerAscriptionFunc(val) {
      for (const item of SeaExportConstants.CONTAINER_ASCRIPTION_TYPE) {
        if (item.code === val) {
          return item.chineseName
        }
      }
    },
    subInSpectedLabelFunc(data) {
      if (data && data.container) {
        const isInSpected = data.container.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    subClassLabelFunction(data, fieldName) {
      if (fieldName === 'eqSize') {
        const eqSize = data.container ? EQSize.getEQSizeByCode(data.container[fieldName]) : null
        return eqSize === null ? '' : eqSize.name
      } else {
        if (!data.container) return ''
        return data.container[fieldName] || ''
      }
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedContainerUsage = event.data
      // this.manifestGoods = event.data
      if (this.$refs.portDataGoodsInfo) {
        this.$refs.portDataGoodsInfo.init(event.data)
      }
      this.isEditGoods = true
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainerUsage = node.data
          }
        })
      }
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    async onCellChange(params) {
      const _job = this.job
      const usage = params.data
      if (!usage) {
        return
      }
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          usage.container.containerNo = usage.containerNo
          await this.syncContainerNoForHbl(params.oldValue, usage.containerNo, usage.sealNo)
          // 同步poItems ContainerNo
          this.syncPoItemsContainerNo(usage)
          await this.syncContainerSealNoForMbl2Hbl2(usage)
          break
        case 'sealNo':
          usage.container.sealNo = usage.sealNo
          // 更改封号同步到HBL拆并单的装箱信息区域
          await this.syncSealNoForHbl(usage.containerNo, usage.sealNo)
          await this.syncContainerSealNoForMbl2Hbl2(usage)
          break
        case 'containerWeight':
          // 箱重处理四舍五入 入库（控件只做了前端显示处理）
          if (usage.containerWeight) {
            usage.containerWeight = roundHalfUp(usage.containerWeight, 3)
            usage.container.containerWeight = usage.containerWeight
          } else {
            usage.containerWeight = 0
            usage.container.containerWeight = usage.containerWeight
          }
          this.syncVgmInfo(usage.container)
          break
        case 'containerAscription':
          usage.container.containerAscription = usage.containerAscription
          break
        case 'cargoName':
          usage.container.cargoName = usage.cargoName
          break
        case 'remark':
          usage.container.remark = usage.remark
          break
        case 'boxController':
          usage.container.boxController = usage.boxController
          break
        case 'mark':
          usage.container.mark = usage.mark
          break
        case 'quantity':
          // 用删除的方式 内容是空 保存null 会报错
          if (!usage.quantity) {
            usage.quantity = 0
          }
          // h5 不需要 quantityChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            await this.updateJobActualQWC('quantityContract')
            this.refreshQWC()
            if (usage.container) {
              usage.container.quantity = usage.quantity
            }
          }
          usage.isDirty = true
          break
        case 'weight':
          if (!usage.weight) {
            usage.weight = 0
          }
          // h5 不需要  weightChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            await this.updateJobActualQWC('weightContract')
            this.refreshQWC()
            if (usage.container) {
              usage.container.weight = usage.weight
            }
          }
          this.syncVgmInfo(usage.container)
          break
        case 'cubage':
          if (!usage.cubage) {
            usage.cubage = 0
          }
          // h5 不需要  cubageChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            await this.updateJobActualQWC('cubageContract')
            this.refreshQWC()
            if (usage.container) {
              usage.container.cubage = usage.cubage
            }
          }
          break
        case 'lfd':
          usage.container.lfd = usage.lfd
          break
        case 'destinationDeliveryTime':
          usage.container.destinationDeliveryTime = usage.destinationDeliveryTime
          break
        case 'destinationReturnTime':
          usage.container.destinationReturnTime = usage.destinationReturnTime
          break
        case 'portDischargeTime':
          usage.container.portDischargeTime = usage.portDischargeTime
          break
        case 'actualPickUpTime':
          usage.container.actualPickUpTime = usage.actualPickUpTime
          break
        case 'sizeLength':
          usage.container.sizeLength = usage.sizeLength
          break
        case 'sizeWidth':
          usage.container.sizeWidth = usage.sizeWidth
          break
        case 'sizeHeight':
          usage.container.sizeHeight = usage.sizeHeight
          break
        case 'quantityContract':
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.syncContractQuantityWeightCubageToJob('quantityContract', 'quantityActual')
          }
          break
        case 'weightContract':
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.syncContractQuantityWeightCubageToJob('weightContract', 'weightActual')
          }
          break
        case 'cubageContract':
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.syncContractQuantityWeightCubageToJob('cubageContract', 'cubageActual')
          }
          break
        case 'reefTemperature':
          usage.container.reefTemperature = usage.reefTemperature
          break
        case 'ventilate':
          usage.container.ventilate = usage.ventilate
          // 关闭通风，清空 通风量
          if (!usage.ventilate) {
            usage.reefVentilation = usage.humidity = usage.reefTemperature = ''
            usage.container.reefVentilation = usage.container.humidity = usage.container.reefTemperature = ''
          }
          break
        case 'reefVentilation':
          usage.container.reefVentilation = usage.reefVentilation
          break
        case 'humidity':
          usage.container.humidity = usage.humidity
          break
        case 'overSize':
          usage.container.overSize = usage.overSize
          if (!usage.overSize) {
            usage.overFront = usage.container.overFront = 0
            usage.overBack = usage.container.overBack = 0
            usage.overLeft = usage.container.overLeft = 0
            usage.overRight = usage.container.overRight = 0
            usage.overHeight = usage.container.overHeight = 0
            usage.oogTeu = usage.container.oogTeu = 0
            usage.overSizeData = ''
          }
          break
        case 'checkBbk':
          usage.container.checkBbk = usage.checkBbk
          break
        case 'oogTeu':
          usage.container.oogTeu = usage.oogTeu
          break
        case 'relevanceSoNo':
          usage.relevanceSoNo = usage.relevanceSoNo.join()
          break
        case 'reefTempUnit':
          usage.container.reefTempUnit = usage.reefTempUnit
          break
        case 'ventilationUnit':
          usage.container.ventilationUnit = usage.ventilationUnit
          break
        default:
          break
      }
      if (this.gridApi) this.gridApi.refreshCells({ force: true })
    },
    // 同步箱号到MBL拆并单、HBL拆并单
    async syncContainerSealNoForMbl2Hbl2(containerUsage) {
      let updatedEdiContainer = false
      const seaCargoDocs = await new SeaExportJob(this.job).getSeaCargoDoc()
      for (const cargoDoc of seaCargoDocs) {
        if (cargoDoc.docType !== CargoDocConsts.MBL2 && cargoDoc.docType !== CargoDocConsts.HBL2) {
          continue
        }
        await new SeaCargoDoc(cargoDoc).getEdiContainer()
        if (!cargoDoc.ediContainer || cargoDoc.ediContainer.length <= 0) {
          continue
        }
        for (const item of cargoDoc.ediContainer) {
          if (item.deleted) {
            continue
          }
          if (item.containerUsageUuid && item.containerUsageUuid === containerUsage.uuid) {
            item.containerNo = containerUsage.containerNo
            item.sealNo = containerUsage.sealNo
            updatedEdiContainer = true
          }
        }
      }
      if (updatedEdiContainer) {
        this.isUpdateCargoDoc = true
        this.$message.success(this.$t('Message.SyncContainerSealNoToBillOfLading'))
      } else {
        if (containerUsage.ediContainers && containerUsage.ediContainers.length > 0) {
          for (const ediContainer of containerUsage.ediContainers) {
            if (ediContainer.containerNo !== containerUsage.containerNo || ediContainer.sealNo !== containerUsage.sealNo) {
              this.$message.success(this.$t('Message.SyncContainerSealNoToBillOfLading'))
              break
            }
          }
        }
      }
    },
    syncContractQuantityWeightCubageToJob(contractField, actualField) {
      let num = 0
      for (const usage of this.containerUsages) {
        num += Number(usage[contractField]) || 0
      }
      if (num > 0) {
        this.job[contractField] = num
        const rule = Number(this.config.get('SEQuantityWeightCubageRule'))
        if (rule === 1 || rule === 2) {
          this.job[actualField] = num
          ContainerUtil.refreshContainerUsageActualQwc(this.job)
        }
      }
    },
    // CARGO-8570 海出详情VGM页面，VGM重量自动计算
    syncVgmInfo(container) {
      ContainerUtil.refreshVgmWeight(container)
    },
    /**
     * 计算件毛体总数
     */
    refreshQWC() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.containerUsages) {
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
    },
    async updateJobActualQWC(contractField) {
      this.isUpdateCargoDoc = true
      await ContainerUtil.refContainerUsageQwc(this.job, 1)
      // CARGO-7908
      const expression = Number(this.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic) {
        await ContainerUtil.refContainerUsageQwc(this.job, 3)
      }
      const rule = Number(this.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        ContainerUtil.refreshContainerUsageContractQwc(this.job, contractField)
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 查验更改封号
    changeSealHandler() {
      if (!this.selectedContainerUsage) {
        return
      }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号 回调事件
    sealCloseHandler(data) {
      const usage = this.selectedContainerUsage
      if (usage.container.sealNo !== data.sealNo) {
        usage.isReSealed = true
        usage.container.inSpected = true
      }
      usage.container.sealNo = data.sealNo
      usage.container.containerNo = data.containerNo
      usage.container.remark = data.remark

      usage.container.isDirty = true

      // 箱子信息列字段移至 usage
      usage.sealNo = data.sealNo
      usage.containerNo = data.containerNo
      usage.remark = data.remark

      this.syncContainerSealNoForMbl2Hbl2(usage)

      this.gridApi.refreshCells({ force: true })
    },
    // 自动装箱
    async autoLoadHandler() {
      // 当前小票下的箱子只要有过对比，就进行弹窗提醒
      if (this.job.containers.length > 0) {
        if (this.job.containers.find(item => item.confirmed > 0)) {
          this.$confirm(this.$t('Integrated.YourWeightAndVolumeTo'), this.$t('SeaExport.Prompt'), {
            confirmButtonText: this.$t('SeaExport.GotIt'),
            showCancelButton: false,
            type: 'info'
          })
        }
      }
      ContainerUtil.autoLoadContainerUsage(this.job)
      // CARGO-32977 装箱信息-自动装箱品名唛头带入调整
      await this.syncCargoNameAndMark()
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.containerUsages)
      this.refreshTotal()
    },
    // 自动装箱(委托)
    autoLoadContractHandler() {
      ContainerUtil.autoLoadContainerUsageContract(this.job)
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.containerUsages)
    },
    // 清空装箱记录
    autoUnloadHandler() {
      const usage = this.selectedContainerUsage
      if (usage) {
        if (!this.checkRelatedEdiContainer([usage])) {
          return
        }
        usage.container.containerNo = ''
        usage.container.sealNo = ''
        usage.weight = 0
        usage.quantity = 0
        usage.cubage = 0
        usage.weightContract = 0
        usage.quantityContract = 0
        usage.cubageContract = 0
        usage.hsCode = ''
        usage.container.cargoName = ''
        usage.cargoName = ''

        // 箱子信息列字段移至 usage
        usage.containerNo = ''
        usage.sealNo = ''

        usage.container.isDirty = true
        usage.isDirty = true
        usage.boxController = ''
        usage.carNumber = ''
        usage.container.boxController = ''
        usage.container.carNumber = ''
      }
      this.gridOptions.api.applyTransaction({ update: [usage] })
      this.refreshTotal()
    },
    // 删除装箱记录
    deleteContainerHandler() {
      const items = this.gridApi.getSelectedRows()
      if (items.length === 0) {
        return
      }
      if (!this.checkRelatedEdiContainer(items)) {
        return
      }
      for (const usage of items) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(usage.uuid)) {
          if (!this.job.delContainerUuids) {
            this.job.delContainerUuids = []
          }
          this.job.delContainerUuids.push(usage.containerUuid)
        }
        const poItems = usage.poItems
        if (poItems) {
          poItems.forEach(item => {
            if (!StrUtils.isEmpty(item.uuid)) {
              this.delPoItemsUuids.push(item.uuid)
            }
          })
        }
        const index = this.containerUsages.findIndex(p => p === usage)
        this.containerUsages.splice(index, 1)
      }
      if (this.$refs.portDataGoodsInfo) {
        this.$refs.portDataGoodsInfo.clear()
      }
      this.manifestGoods = {}
      this.isEditGoods = false
      this.refreshTotal()
      this.gridApi.clearFocusedCell()
    },
    // 校验是否有关联的提单装箱信息
    checkRelatedEdiContainer(usages) {
      for (const usage of usages) {
        if (usage.ediContainers && usage.ediContainers.length > 0) {
          this.$message.warning(this.$t('Message.AssociatedBillOfLadingCannotDelete'))
          return false
        }
      }
      return true
    },
    // 查看关联业务
    showAWindowClickHandler() {
      if ((!this.job.relatedJob && this.job.trustFromJob) || this.job.relatedJob && !this.job.trustFromJob) {
        const params =
        {
          trustFromJobNo: this.job.trustFromJob,
          relatedJobNo: this.job.relatedJob
        }
        // 调用api
        queryAssociatedBusiness(params).then(res => {
          this.queryWindowResultHandler(res.data)
        })
      }
    },
    queryWindowResultHandler(data) {
      if (!data) return
      this.associatedBusinessDialog.aData = data
      this.associatedBusinessDialog.visible = true
    },
    // 刷新
    async refresh() {
      if (this.job && !StrUtils.isEmpty(this.job.uuid)) {
        const job = new SeaExportJob(this.job)
        job.seaEQ = ''
        job.containers = ''
        job.containerUsages = ''
        await Promise.all([
          job.getSeaEQ(),
          job.getContainerUsages(),
          job.getContainers()
        ])
        await this.jobChanged()
      }
    },
    // 模板下载
    downTemplateBtn_clickHandler() {
      const fileName = 'ContainerUsageImportTemplate.xls'
      const folderName = 'booking'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // excel导入
    importExcelEventHandler(item) {
      const usages = lodash.cloneDeep(this.job.containerUsages)
      // 避免循环引用
      for (const usage of usages) {
        delete usage.container.containerUsage
      }

      const jobObj = { job: { lob: this.job.lob }, seaEQ: this.job.seaEQ, containerUsages: usages }
      const params = {
        file: item.file,
        job: JSON.stringify(jobObj),
        jobUuid: this.job.uuid,
        jobNo: this.job.jobNo
      }
      importExcelData(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.uploadSuccessUsage(response.data)
        }
      })
    },
    // excel导入 后数据处理 importFileHandler
    uploadSuccessUsage(data) {
      if (!data && !this.job) {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
        return
      }
      const usageCompare = []
      for (const usage of this.job.containerUsages) {
        const oldContainer = usage.container
        for (const newUsage of data.containerUsages) {
          // 记录 已匹配的数据 如已参与比较不再 比对
          if (usageCompare.findIndex(p => p === newUsage) > -1) {
            continue
          }
          const newContainer = newUsage.container
          if (oldContainer.eqSize === newContainer.eqSize && oldContainer.eqType === newContainer.eqType) {
            oldContainer.containerNo = newContainer.containerNo
            oldContainer.sealNo = newContainer.sealNo
            oldContainer.containerWeight = newContainer.containerWeight
            oldContainer.remark = newContainer.remark
            oldContainer.cargoName = newContainer.cargoName
            oldContainer.isDirty = true
            oldContainer.boxController = newContainer.boxController
            oldContainer.carNumber = newContainer.carNumber
            oldContainer.weight = newContainer.weight

            usage.containerNo = newContainer.containerNo
            usage.containerWeight = newContainer.containerWeight
            usage.sealNo = newContainer.sealNo
            usage.remark = newContainer.remark
            usage.containerWeight = newContainer.containerWeight
            usage.cargoName = newContainer.cargoName

            usage.quantity = newUsage.quantity
            usage.weight = newUsage.weight
            usage.cubage = newUsage.cubage
            usage.hsCode = newUsage.hsCode
            usage.soc = newUsage.soc
            usage.isDirty = true
            usage.boxController = newContainer.boxController
            usage.carNumber = newContainer.carNumber

            usageCompare.push(newUsage)

            break
          }
        }
      }
      this.refreshTotal()
      this.gridApi.refreshCells({ force: true })
    },
    // 组装打印参数
    getPrintData() {
      const containerUsages = this.gridApi.getSelectedRows()
      if (!containerUsages || containerUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      const params = {}
      if (containerUsages.length === 1) {
        params.CONTAINER_UUID = containerUsages[0].container.uuid
        params.category = 'FCL'
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "FCL", params, this);
      } else {
        const uids = []
        for (const c of containerUsages) {
          if (c.container && c.container.uuid && !uids.includes(c.container.uuid)) {
            uids.push(c.container.uuid)
          }
        }
        params.CONTAINER_UUID = uids
        params.category = 'CONTAINER_LIST'
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
      }
      this.$logger.log('params', params)
      return params
    },
    onRowDragEnd(params) {
      params.api.getModel().rowsToDisplay.forEach(node => {
        node.data.serialNo = node.rowIndex
        this.onCellChange({ data: node.data, colDef: { colId: 'serialNo' }})
      })
    },
    // 更改箱号同步到HBL拆并单的装箱信息区域
    async syncContainerNoForHbl(oldContainerNo = '', containerNo = '', sealNo = '') {
      if (!oldContainerNo) return
      const seaCargoDocs = await new SeaExportJob(this.job).getDocByDocType(CargoDocConsts.HBL2)
      for (const cargoDoc of seaCargoDocs) {
        if (!cargoDoc.ediContainer || cargoDoc.ediContainer.length <= 0) continue
        const ediContainers = cargoDoc.ediContainer || []
        if (!ediContainers || ediContainers.length <= 0) continue
        for (const ediContainer of ediContainers) {
          if (!ediContainer.containerNo || ediContainer.containerNo !== oldContainerNo) continue
          ediContainer.containerNo = containerNo
          ediContainer.sealNo = sealNo
          // 修改提单数据
          if (!this.isUpdateCargoDoc) this.isUpdateCargoDoc = true
        }
      }
    },
    // 更改封号同步到HBL拆并单的装箱信息区域
    async syncSealNoForHbl(containerNo = '', sealNo = '') {
      if (!containerNo) return
      const seaCargoDocs = await new SeaExportJob(this.job).getDocByDocType(CargoDocConsts.HBL2)
      for (const cargoDoc of seaCargoDocs) {
        if (!cargoDoc.ediContainer || cargoDoc.ediContainer.length <= 0) continue
        const ediContainers = cargoDoc.ediContainer || []
        if (!ediContainers || ediContainers.length <= 0) continue
        for (const ediContainer of ediContainers) {
          if (!ediContainer.containerNo || ediContainer.containerNo !== containerNo) continue
          ediContainer.sealNo = sealNo
          // 修改提单数据
          if (!this.isUpdateCargoDoc) this.isUpdateCargoDoc = true
        }
      }
    },
    // 初始处理港区数据
    initGoodsTmpInfo() {
      this.mergeHarbourList = []
      if (this.harbourList.length > 0) {
        this.harbourList.forEach(elements => {
          const isSystemVerificationHasNotConfirm = elements.confirmed === 10 && PortDataCompareUtils.systemVerificationHasNotConfirm(elements.containerNo, this.harbourList)
          if (elements.confirmed === 0 || isSystemVerificationHasNotConfirm) {
            if (this.mergeHarbourList.length === 0) {
              const data = deepClone(elements)
              data.confirmed = 0
              this.mergeHarbourList.push(data)
            } else {
              let isIn = false
              this.mergeHarbourList.forEach(element => {
                if (element.containerNo === elements.containerNo && elements.containerNo && element.containerNo) {
                  isIn = true
                  if (!element.eqSize && elements.eqSize) {
                    element.eqSize = elements.eqSize
                  }
                  if (!element.eqType && elements.eqType) {
                    element.eqType = elements.eqType
                  }
                  if (!element.cargoEnglishName && elements.cargoEnglishName) {
                    element.cargoEnglishName = elements.cargoEnglishName
                  }
                  if (!element.hsCode && elements.hsCode) {
                    element.hsCode = elements.hsCode
                  }
                  if (!element.packing && elements.packing) {
                    element.packing = elements.packing
                  }
                  element.quantity = PortDataCompareUtils.adding(element.quantity, elements.quantity, true)
                  element.weight = PortDataCompareUtils.adding(element.weight, elements.weight, false)
                  element.cubage = PortDataCompareUtils.adding(element.cubage, elements.cubage, false)
                  if (!element.soNo && elements.soNo) {
                    element.soNo = elements.soNo
                  }
                }
              })
              if (!isIn) {
                const data = deepClone(elements)
                data.confirmed = 0
                this.mergeHarbourList.push(data)
              }
            }
          }
        })
      }
    },
    // 初始化获取港区数据
    async initHarbour() {
      await getOpenPortDataService({ jobUuid: this.job.uuid }).then(async(res) => {
        this.openPortDataService = res.data
        if (this.openPortDataService === 4) {
          await checkRead({ jobUuid: this.job.uuid }).then(res => {
            this.harbourCheckRead = !res.data
          })
          await getGoodsTmpInfoByJobId({ jobUuid: this.job.uuid }).then(res => {
            const harbourData = res.data
            let flag = false
            if (harbourData && harbourData.length > 0) {
              for (const data of harbourData) {
                if (data.confirmed !== 0) {
                  flag = true
                }
                // 转化箱种
                data.eqType = PortDataCompareUtils.transformEqType(data.eqType, data.containerHeightCn, this.HQHCFlag)
                this.containerHeightFlag = !!data.containerHeightCn
              }
            }
            this.hasCompareYet = flag
            this.harbourList = harbourData
            this.initGoodsTmpInfo()
          })
        }
      })
    },
    // 初始化港区数据与当前装箱信息对比校验
    initCompare() {
      this.containerUsages.forEach(containerUsage => {
        const container = containerUsage.container
        if (container.confirmed === 0) {
          this.mergeHarbourList.forEach(harborDistrictData => {
            if (container.containerNo === harborDistrictData.containerNo) { // 找到containerNo相同的数据
              if (harborDistrictData.confirmed === 0) {
                if (containerUsage.sealNo !== harborDistrictData.sealno ||
                  container.eqSize !== harborDistrictData.eqSize ||
                  harborDistrictData.eqType.indexOf(containerUsage.eqType) === -1 ||
                  containerUsage.quantity !== harborDistrictData.quantity ||
                  containerUsage.weight !== harborDistrictData.weight ||
                  containerUsage.cubage !== harborDistrictData.cubage) {
                  containerUsage.confirmed = -1
                  // 是否与港区数据一致
                  containerUsage.sameWithHarborDistrict = false
                } else {
                  containerUsage.confirmed = 10
                  // 是否与港区数据一致
                  containerUsage.sameWithHarborDistrict = true
                  this.isAutoLoad = true
                }
              }
            }
          })
        }
        if (containerUsage.confirmed === 10 || containerUsage.confirmed === 11 || containerUsage.confirmed === 12 || containerUsage.confirmed === 13) {
          this.isAutoLoad = true
        }
      })
      // 系统的装箱信息数据
      const updateSystem = []
      this.containerUsages.forEach(uasge => {
        if (!uasge.confirmed) {
          uasge.confirmed = uasge.container.confirmed
        }
        if (uasge.confirmed === 10) {
          updateSystem.push(uasge)
        }
      })
      const result = []
      updateSystem.forEach(uasge => {
        this.harbourList.forEach(harborDistrictData => {
          if (uasge.containerNo === harborDistrictData.containerNo) {
            // 如果和港区一样，就不要变更为已确认状态，否则会导致无法正常比对港区数据
            if (uasge.hasOwnProperty('sameWithHarborDistrict') && uasge.sameWithHarborDistrict) {
              harborDistrictData.confirmed = 0
            } else {
              harborDistrictData.confirmed = 10
            }
            result.push({
              uuid: harborDistrictData.uuid,
              confirmed: 10,
              jobUuid: this.job.jobUuid
            })
            this.isAutoLoad = true
          }
        })
      })
      this.$nextTick(() => {
        if (this.gridApi) this.gridApi.refreshCells({ force: true })
      })
    },
    // 数据对比弹框
    harbourCompare() {
      if (this.openPortDataService !== 4) {
        this.harbourWarnMessage()
        return
      }
      // 没有港区数据时提醒
      if (!this.harbourList || this.harbourList.length === 0) {
        this.$message.warning(this.$t('SeaExport.NoPortDataHasBeenObtained'))
        return
      }
      this.sourceList = [...this.harbourList]
      this.harbourDialog = true
      if (this.harbourCheckRead) {
        updateRead({ jobUuid: this.job.uuid }).then(() => {
          this.harbourCheckRead = false
        })
      }
    },
    // 同步港区数据
    harbourSync() {
      if (this.openPortDataService === 4) {
        this.$confirm(`<strong>【${this.$t('SeaExport.SynchronizePortData')}】${this.$t('SeaExport.TheOverwriteTheCurrentData')}</strong><br/><span style='color: red'>${this.$t('SeaExport.ThisActionCannotBeUndone')}</span>，${this.$t('SeaExport.DoYouWantToContinue')}`, this.$t('Message.Prompt'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('Invoice.invoice_confirm'),
          cancelButtonText: this.$t('Message.Cancel'),
          type: 'warning'
        }).then(() => {
          if (this.harbourCheckRead) {
            updateRead({ jobUuid: this.job.uuid }).then(() => {
              this.harbourCheckRead = false
            })
          }
          this.syncData()
          // 同步港区后需要重新刷新装箱信息的件毛体合计
          this.refreshQWC()
        }).catch(() => {

        })
      } else {
        this.harbourWarnMessage()
      }
    },
    harbourWarnMessage() {
      let message = ''
      switch (this.openPortDataService) {
        case 1:
          message = this.$t('SeaExport.HarbourNotInServiceNoOpen') + '021-65143931。'
          break
        case 2:
          message = this.$t('SeaExport.HarbourInServiceNoOpen') + '021-65143931。'
          break
        case 3:
          message = this.$t('SeaExport.HarbourNotInServiceOpen')
          break
      }
      const h = this.$createElement
      this.$msgbox({
        message: h('div', { class: 'portData-service' }, [
          h('i', { class: 'el-icon-warning' }, ''),
          h('span', null, this.$t('Message.Prompt')),
          h('p', null, message)
        ]),
        showCancelButton: false,
        confirmButtonText: this.$t('Message.GotIt')
      }).then(() => {
      })
    },
    syncData() {
      this.isAutoLoad = false
      const harbourList = []
      this.harbourList.forEach(item => {
        item.confirmed = 10
      })
      const tempHarbour = deepClone(this.harbourList)
      this.selection = []
      // 按箱型重新排序
      this.containerUsages.sort((a, b) => {
        // 检查 a 的箱号是否为空
        if (!a.containerNo) return 1 // 如果 a 箱号为空，将其排在后面

        // 检查 b 的箱号是否为空
        if (!b.containerNo) return -1 // 如果 b 箱号为空，将其排在后面
        // 先按箱号排序
        if (a.containerNo < b.containerNo) return -1
        if (a.containerNo > b.containerNo) return 1
        return b.eqType.localeCompare(a.eqType)
      })
      this.containerUsages.forEach((element, keys) => {
        // 覆盖原货物信息
        element.poItems.forEach(item => {
          if (StrUtils.isEmpty(item.uuid)) {
            this.delPoItemsUuids.push(item.uuid)
          }
        })
        element.poItems = []
        delete element.type
        tempHarbour.forEach((eve, index) => {
          // 箱号不为空，且箱号相同的数据，或当前业务的箱号为空，港区的箱号不为空且箱型箱量相同的
          if ((!StrUtils.isEmpty(eve.containerNo) && (eve.containerNo === element.containerNo)) ||
            (StrUtils.isEmpty(element.containerNo) && eve.containerNo && element.eqSize === eve.eqSize && (eve.eqType === element.eqType || eve.eqType.indexOf(element.eqType) > -1))) {
            element.containerNo = eve.containerNo
            element.sealNo = eve.sealno
            eve.eqType = eve.eqType instanceof Array ? (eve.eqType.length === 1 ? eve.eqType[0] : element.eqType) : eve.eqType
            if (element.eqSize !== eve.eqSize || element.eqType !== eve.eqType) {
              PortDataCompareUtils.changeSeaEQ(this.job.seaEQ, element.eqSize, element.eqType, eve.eqSize, eve.eqType, this.job)
              element.eqSize = eve.eqSize
              element.eqType = eve.eqType
              element.container.eqSize = eve.eqSize
              element.container.eqType = eve.eqType
            }
            PortDataCompareUtils.syncPortDate(eve, element)
            PortDataCompareUtils.syncPortDate(eve, element.container)
            element.container.isDirty = true
            element.confirmed = 10
            const poItem = deepClone(eve)
            poItem.uuid = ''
            poItem.containerUsageKey = element.uuid
            poItem.grossWeight = eve.weight
            if (!element.poItems) {
              element.poItems = []
            }
            element.poItems.push(poItem)
            this.isAutoLoad = true
            this.selection.push({
              uuid: eve.uuid,
              confirmed: 10,
              jobUuid: this.job.jobUuid
            })
            harbourList.push(eve.uuid)
          }
        })
        PortDataCompareUtils.removeHarbourData(harbourList, tempHarbour)
      })
      // 箱号不一致 && 没有匹配的箱型箱种 && 港区数据 >= 当前数据
      const newUsages = {}
      tempHarbour.forEach((eve, index) => {
        eve.jobUuid = this.job.uuid
        eve.eqType = eve.eqType[0]
        PortDataCompareUtils.addNewContainerUsages(eve, newUsages)
        this.isAutoLoad = true
        this.selection.push({
          uuid: eve.uuid,
          confirmed: 10,
          jobUuid: this.job.jobUuid
        })
      })
      this.containerUsages.forEach((element, keys) => {
        let quantity = 0
        let weight = 0.000
        let cubage = 0.000
        if (element.poItems) {
          element.poItems.forEach(data => {
            quantity += data.quantity ? parseInt(data.quantity) : 0
            weight += data.grossWeight ? parseFloat(data.grossWeight) : 0
            cubage += data.cubage ? parseFloat(data.cubage) : 0
          })
        }
        element.container.containerNo = element.containerNo
        element.quantity = NumberUtils.formatNumber(quantity, 0)
        element.weight = NumberUtils.formatNumber(weight, 3)
        element.cubage = NumberUtils.formatNumber(cubage, 3)
      })
      for (const key in newUsages) {
        const item = newUsages[key]
        const container = item.container
        const containerUsage = item
        const seaEQ = item.seaEQ
        container.confirmed = 10
        container.containerUsage = []
        container.containerUsage.push(containerUsage)
        this.job.containers.push(container)
        PortDataCompareUtils.addSeaEQ(this.job.seaEQ, seaEQ.eqType, seaEQ.eqSize)
        item.confirmed = 10
        this.containerUsages.push(item)
      }
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
    },
    handleAddContainer(delUsageKeys, delPoItemKeys, selection, selectHarbours) {
      this.isAutoLoad = false
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const usage of this.containerUsages) {
        if (usage.isDirty) {
          this.isAutoLoad = true
          usage.container.confirmed = usage.confirmed
          usage.container.eqSize = usage.eqSize
          usage.container.eqType = usage.eqType
        }
        usage.container.containerNo = usage.containerNo
        if (usage.type === '新增') {
          if (usage.container) {
            usage.container.quantity = usage.quantity
            usage.container.weight = usage.weight
            usage.container.cubage = usage.cubage
          }
          if (usage.poItems === '') {
            usage.poItems = []
          }
          // 处理从装箱信息数据对比新增的箱子
          if (StrUtils.isEmpty(usage.uuid)) {
            const container = usage.container
            const containerUsage = usage
            const seaEQ = usage.seaEQ
            container.containerUsage = []
            container.containerUsage.push(containerUsage)
            container.isDirty = true
            this.job.containers.push(container)
            PortDataCompareUtils.addSeaEQ(this.job.seaEQ, seaEQ.eqType, seaEQ.eqSize)
          }
        }
      }
      this.selection = selection
      if (delPoItemKeys && delPoItemKeys.length > 0) {
        this.delPoItemsUuids = this.delPoItemsUuids.concat(delPoItemKeys)
      }
      // 处理已勾选的港区数据
      if (selectHarbours && selectHarbours.length > 0) {
        for (const data of this.harbourList) {
          if (selectHarbours.indexOf(data.uuid) > -1) {
            data.confirmed = 11
          }
        }
      }
      if (delUsageKeys && delUsageKeys.length > 0) {
        this.job.delContainerUuids = this.job.delContainerUuids.concat(delUsageKeys)
      }
      this.gridApi.clearFocusedCell()
      this.gridApi.refreshCells({ force: true })
      if (this.$refs.portDataGoodsInfo) {
        this.$refs.portDataGoodsInfo.init({})
      }
      this.initGoodsTmpInfo()
      // 数据对比后需要重新刷新装箱信息的件毛体合计
      this.refreshQWC()
      this.lbTotalDesc.lblContainerDesc = ContainerUtil.getContainerDesc(this.job)
      this.updateJobActualQWCByFields(['quantityContract', 'weightContract', 'cubageContract'])
    },
    handleChange(obj) {
      this.containerUsages.forEach(eve => {
        if ((!StrUtils.isEmpty(obj.uuid) && eve.uuid === obj.uuid) ||
          (StrUtils.isEmpty(obj.uuid) && eve.containerNo === obj.containerNo)) {
          eve.quantity = obj.quantity
          eve.weight = obj.weight
          eve.cubage = obj.cubage
        }
      })
      this.gridApi.setRowData(this.containerUsages)
      this.refreshQWC()
    },
    // 处理表格颜色
    containerPushDataStyleFunction(params, columnDataField) {
      if (params.data.confirmed > 0) {
        return { color: '' }
      }
      const warningClass = { color: '#f56c6c' }
      let result = false
      this.mergeHarbourList.forEach(eve => {
        if (eve.containerNo === params.data.containerNo) {
          // 如果是箱型
          if (columnDataField === 'eqType') {
            result = eve[columnDataField] instanceof Array ? eve[columnDataField].indexOf(params.data[columnDataField]) === -1 : params.data[columnDataField] !== eve[columnDataField]
          } else {
            result = params.data[columnDataField] !== eve[columnDataField]
          }
        }
      })
      return result ? warningClass : { color: '' }
    },
    // 送仓时间、还空时间显示
    destinationDisplayFunction(params, field) {
      if (params.data && params.data.container) {
        const tempTime = params.data.container[field]
        return tempTime ? ColumnUtils.dateLabelFunc(tempTime) : ''
      }
      return ''
    },
    // 卸船时间、提重时间显示
    actualDisplayFunction(params, field) {
      if (params.data && params.data.container) {
        const tempTime = params.data.container[field]
        return tempTime ? ColumnUtils.dateTimeLabelFunc(tempTime) : ''
      }
      return ''
    },
    syncPoItemsContainerNo(usage) {
      if (usage.poItems && usage.poItems.length > 0) {
        for (const item of usage.poItems) {
          item.containerNo = usage.containerNo
        }
      }
    },
    // 抄录门点拖柜信息
    copyDoorPointData() {
      this.containerRecordDialog.visible = true
    },
    // 选择做柜信息
    selectTruckingRecordHandler(records) {
      this.containerUsages.forEach((element, keys) => {
        for (const record of records) {
          if (element.container.containerId === record.containerId) {
            element.container.containerNo = record.containerNo
            element.container.quantity = record.quantity
            element.container.weight = record.weight
            element.container.cubage = record.cubage
            element.container.containerWeight = record.containerWeight
            element.container.sealNo = record.sealNo
            element.container.plateNumber = record.truckNo

            element.containerNo = record.containerNo
            element.quantity = record.quantity
            element.weight = record.weight
            element.cubage = record.cubage
            element.containerWeight = record.containerWeight
            element.plateNumber = record.truckNo
            element.sealNo = record.sealNo
          }
        }
      })
      this.gridApi.clearFocusedCell()
      this.gridApi.refreshCells({ force: true })
    },
    /**
     * CARGO-32977 装箱信息-自动装箱品名唛头带入调整
     * @returns {Promise<void>}
     */
    async syncCargoNameAndMark() {
      if (!this.job.containerUsages) return
      let cargoName = ''
      let mark = ''
      const hblDoc = this.job.signHBL ? await new SeaExportJob(this.job).getMainHbl() : ''
      if (hblDoc && (!StrUtils.isEmpty(hblDoc.mark) || !StrUtils.isEmpty(hblDoc.cargoEnglishName))) {
        cargoName = hblDoc.cargoEnglishName || ''
        mark = hblDoc.mark || ''
      } else {
        const mblDoc = this.job.signMBL ? await new SeaExportJob(this.job).getMainMbl() : ''
        if (mblDoc && (!StrUtils.isEmpty(mblDoc.mark) || !StrUtils.isEmpty(mblDoc.cargoEnglishName))) {
          cargoName = mblDoc.cargoEnglishName || ''
          mark = mblDoc.mark || ''
        }
      }
      if (mark || cargoName) {
        for (const usage of this.job.containerUsages) {
          if (!usage.container) continue
          usage.container.cargoName = usage.cargoName = cargoName
          usage.container.mark = usage.mark = mark
        }
      }
    },
    async updateJobActualQWCByFields(contractFields) {
      this.isUpdateCargoDoc = true
      await ContainerUtil.refContainerUsageQwc(this.job, 1)
      // CARGO-7908
      const expression = Number(this.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic) {
        await ContainerUtil.refContainerUsageQwc(this.job, 3)
      }
      const rule = Number(this.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        for (const contractField of contractFields) {
          ContainerUtil.refreshContainerUsageContractQwc(this.job, contractField)
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    async xhqShowSendContainerHandler() {
      if (!this.selectedContainerUsage) {
        this.selectedContainerUsage = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null
      }
      if (!this.selectedContainerUsage) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      this.xhqSendContainerDialog.container = this.selectedContainerUsage.container
      this.xhqSendContainerDialog.containerUsage = []
      this.xhqSendContainerDialog.containerUsage.push(this.selectedContainerUsage)
      const containerUsage = this.xhqSendContainerDialog.containerUsage
      const jobUuidList = Array.from(containerUsage, p => p.jobUuid)
      const dataList = await xhqGetContainerLclList(jobUuidList).then(res => {
        return res.data
      })
      if (dataList && dataList.length > 0) {
        for (const item of containerUsage) {
          const dataMap = dataList.find(p => p.jobUuid === item.jobUuid)
          if (dataMap.xhqCustomState === XhqCustomState.NOT_SENT.code) {
            item.tips = this.$t('CargoMsg.NotSentCustomsFile')
          }
          if (!dataMap.customs) {
            item.remarks = this.$t('CargoMsg.SelfDeclaration')
          }
        }
      }
      this.xhqSendContainerDialog.visible = true
    },
    // 存在特殊箱子
    hasReefer() {
      if (this.containerUsages && this.containerUsages.length > 0) {
        for (const item of this.containerUsages) {
          if (item.reefer) {
            return true
          }
        }
      }
      return false
    },
    // 存在超尺寸箱子
    hasOverSize() {
      if (this.containerUsages && this.containerUsages.length > 0) {
        for (const item of this.containerUsages) {
          if (item.specialSize) {
            return true
          }
        }
      }
    },
    isShowSize() {
      if (this.containerUsages && this.containerUsages.length > 0) {
        const eqTypeMap = new Map()
        for (const item of this.containerUsages) {
          let isSpecialSize = false
          if (eqTypeMap.has(item.eqType)) {
            isSpecialSize = eqTypeMap.get(item.eqType)
          } else {
            const eqType = getObjectByCache(TYPE_NAMES.basic_data_EQType, 'code', item.eqType)
            if (eqType) {
              isSpecialSize = eqType.specialSize
              eqTypeMap.set(eqType.code, isSpecialSize)
            }
          }
          if (isSpecialSize) {
            return true
          }
        }
      }
      return false
    },
    dimensionEditable(params) {
      const eqType = getObjectByCache(TYPE_NAMES.basic_data_EQType, 'code', params.data.eqType)
      return this.dgContainerEditable && this.isEdit && eqType.specialSize
    },
    calculationDimension(params) {
      const usage = params.data
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      usage.container.sizeLength = usage.sizeLength
      usage.container.sizeWidth = usage.sizeWidth
      usage.container.sizeHeight = usage.sizeHeight
      if ((!usage.sizeLength || usage.sizeLength === 0) && (!usage.sizeWidth || usage.sizeWidth === 0) && (!usage.sizeHeight || usage.sizeHeight === 0)) {
        usage.dimension = ''
      } else {
        usage.dimension = (usage.sizeLength || ' ') + '*' + (usage.sizeWidth || ' ') + '*' + (usage.sizeHeight || ' ')
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    calculationOverSizeData(params) {
      const usage = params.data
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      usage.container.overFront = usage.overFront
      usage.container.overBack = usage.overBack
      usage.container.overLeft = usage.overLeft
      usage.container.overRight = usage.overRight
      usage.container.overHeight = usage.overHeight
      if ((!usage.overFront || usage.overFront === 0) && (!usage.overBack || usage.overBack === 0) && (!usage.overLeft || usage.overLeft === 0) &&
          (!usage.overRight || usage.overRight === 0) && (!usage.overHeight || usage.overHeight === 0)) {
        usage.overSizeData = ''
      } else {
        usage.overSizeData = (usage.overLeft || ' ') + '-' + (usage.overRight || ' ') + '-' + (usage.overFront || ' ') + '-' + (usage.overBack || ' ') + '-' + (usage.overHeight || ' ')
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    async toReleaseJY() {
      const flg = await checkIfReleased({ jobUuid: this.job.uuid }).then(res => {
        return res.data
      })
      if (flg) {
        this.$message.warning(this.$t('SeaExport.AlreadySentReleaseGoods'))
        return
      }
      this.jyReleaseDialog.containers = []
      this.jyReleaseDialog.containers = await new Job(this.job).getContainers()
      this.jyReleaseDialog.visible = true
    },
    toTakeContainerJY() {
      this.jyTakeContainerDialog.containers = []
      const containerUsages = this.gridApi.getSelectedRows()
      for (const usage of containerUsages) {
        if (usage.container) {
          this.jyTakeContainerDialog.containers.push(usage.container)
        }
      }
      if (this.jyTakeContainerDialog.containers.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      this.jyTakeContainerDialog.visible = true
    },
    editNcmNoHandler(ncm) {
      this.ncnEditDialog.containers = []
      const containerUsages = this.gridApi.getSelectedRows()
      for (const usage of containerUsages) {
        if (usage.container) {
          this.ncnEditDialog.containers.push(usage.container)
        }
      }
      if (this.ncnEditDialog.containers.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      if (ncm) {
        this.ncnEditDialog.title = 'NCM NO.'
        this.ncnEditDialog.isNcmNo = ncm
      } else {
        this.ncnEditDialog.title = this.$t('CargoMsg.Cargo_WoodenPackagingType')
        this.ncnEditDialog.isNcmNo = ncm
      }
      this.ncnEditDialog.visible = true
    },
    ncnEditChange(data) {
      if (data) {
        const clear = data.clear // 清空并保存
        const containerUsages = this.gridApi.getSelectedRows()
        for (const usage of containerUsages) {
          if (data.isNcmNo) {
            if (data.ncmNo || (!data.ncmNo && clear)) {
              usage.ncmNo = clear ? '' : data.ncmNo
              if (usage.container) {
                usage.container.ncmNo = clear ? '' : data.ncmNo
                usage.container.isDirty = true
              }
            }
          } else {
            usage.woodenPackagingType = data.packagingType
            if (usage.container) {
              usage.container.woodenPackagingType = data.packagingType
              usage.container.isDirty = true
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    toContainerPreloadJY() {
      this.jyContainerPreloadDialog.containers = []
      const containerUsages = this.gridApi.getSelectedRows()
      for (const usage of containerUsages) {
        if (usage.container) {
          this.jyContainerPreloadDialog.containers.push(usage.container)
        }
      }
      if (this.jyContainerPreloadDialog.containers.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      this.jyContainerPreloadDialog.visible = true
    },
    toCancelContainerPreloadJY() {

    },
    showLclDynamicList() {
      this.jyLclDynamicDialog.visible = !this.jyLclDynamicDialog.visible
    },
    toEDIContainers() {
      this.apiPopup.title = this.$t('SeaExport.ContainerInfo') + ' API'
      this.apiPopup.interfaceArray = '1'
      this.apiPopup.interfaceType = 5
      this.apiPopup.visible = true
    },
    async selectedApiCallback(row) {
      if (row) {
        const loading = getLoading4Cxt()
        let param = {}
        try {
          const inteface = row['id'].toString()
          if (inteface === '1') {
            const containerUsages = []
            for (const usage of this.containerUsages) {
              containerUsages.push({
                containerNo: usage.containerNo,
                sealNo: usage.sealNo,
                quantity: usage.quantity,
                weight: usage.weight,
                cubage: usage.cubage })
            }
            param = {
              jobUuid: this.job.uuid,
              jobNo: this.job.jobNo,
              sendType: EdiType.CONTAINERS_EDI.code, // 装箱数据
              containerRequests: containerUsages
            }
          }
        } catch {
          loading.close()
          return
        }
        ediApi.getMingShenBookingAPI(param).then(result => {
          if (result.data.success) {
            this.$message.success(this.$t('Message.SuccessfullySent'))
          } else {
            this.$message.error(result.data.message)
          }
        }).catch(message => {
          this.$message.error(message)
        }).finally(() => {
          loading.close()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-main-content {
  .operations {
    .triggers {
      overflow: visible;

      div {
        .el-badge {
          margin: 0 0 3px 5px;
        }
      }
    }
  }
}

.portData-service {
  padding-top: 10px;

  &>i {
    margin-right: 5px;
    color: #409EFF;
    font-size: 30px;
    vertical-align: middle;
  }

  &>span {
    line-height: 32px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }

  &>p {
    padding: 10px 0 10px 35px;
    line-height: 22px;
    font-size: 14px;
  }
}
</style>
<style lang="scss">
#tabContainer {
  .el-dialog__wrapper {
    pointer-events: none;
  }

  .el-dialog {
    pointer-events: auto;
  }
}
</style>
